module.exports = __webpack_public_path__ + "img/ep-1-dosis.bfd32f23.jpg";